import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { UsersIcon, CopyIcon, CheckCircleIcon, GiftIcon } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { useAuth } from '../../lib/AuthContext';
export function ReferralPage() {
  const {
    currentCustomer,
    isCustomerLoggedIn
  } = useAuth();
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    if (currentCustomer) {
      navigator.clipboard.writeText(currentCustomer.referralCode).catch(() => {});
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };
  return <div className="max-w-4xl mx-auto px-4 py-8" data-id="element-1548">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} data-id="element-1549">
        <div className="flex items-center gap-3 mb-6" data-id="element-1550">
          <h1 className="text-2xl font-bold text-white flex items-center gap-3" data-id="element-1551">
            <UsersIcon className="w-7 h-7 text-[#C8A84E]" data-id="element-1552" />
            Giới Thiệu Bạn Bè
          </h1>
          <Badge variant="warning" size="md" data-id="element-1553">
            Sắp Ra Mắt
          </Badge>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.05
    }} data-id="element-1554">
        <Card className="text-center mb-6" data-id="element-1555">
          <div className="w-20 h-20 bg-[#C8A84E]/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1556">
            <GiftIcon className="w-10 h-10 text-[#C8A84E]" data-id="element-1557" />
          </div>
          <h2 className="text-xl font-bold text-white mb-2" data-id="element-1558">
            Giới Thiệu Bạn, Cả Hai Cùng Nhận Thưởng
          </h2>
          <p className="text-[#B0B0B0] mb-6 max-w-md mx-auto" data-id="element-1559">
            Khi bạn bè đăng ký và nạp tiền qua mã giới thiệu của bạn, cả hai sẽ
            nhận được tín dụng thưởng.
          </p>

          {isCustomerLoggedIn && currentCustomer && <div className="bg-[#141414] border border-[#2A2A2A] rounded-lg p-4 max-w-sm mx-auto mb-4" data-id="element-1560">
              <p className="text-xs text-[#666666] mb-1" data-id="element-1561">
                Mã giới thiệu của bạn
              </p>
              <div className="flex items-center gap-2" data-id="element-1562">
                <span className="text-2xl font-bold text-[#C8A84E] tracking-wider flex-1" data-id="element-1563">
                  {currentCustomer.referralCode}
                </span>
                <Button size="sm" variant="secondary" onClick={handleCopy} data-id="element-1564">
                  {copied ? <CheckCircleIcon className="w-4 h-4" data-id="element-1565" /> : <CopyIcon className="w-4 h-4" data-id="element-1566" />}
                  {copied ? 'Đã sao' : 'Sao chép'}
                </Button>
              </div>
            </div>}

          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#F59E0B]/10 border border-[#F59E0B]/20 rounded-lg" data-id="element-1567">
            <span className="text-sm text-[#F59E0B]" data-id="element-1568">
              ⏳ Tính năng này sẽ được ra mắt trong Phase 2
            </span>
          </div>
        </Card>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1569">
        <Card className="text-center" data-id="element-1570">
          <div className="text-2xl mb-2" data-id="element-1571">📤</div>
          <h3 className="font-semibold text-white mb-1" data-id="element-1572">Chia Sẻ Mã</h3>
          <p className="text-sm text-[#B0B0B0]" data-id="element-1573">Gửi mã giới thiệu cho bạn bè</p>
        </Card>
        <Card className="text-center" data-id="element-1574">
          <div className="text-2xl mb-2" data-id="element-1575">👤</div>
          <h3 className="font-semibold text-white mb-1" data-id="element-1576">Bạn Bè Đăng Ký</h3>
          <p className="text-sm text-[#B0B0B0]" data-id="element-1577">Bạn bè đăng ký và nạp tiền</p>
        </Card>
        <Card className="text-center" data-id="element-1578">
          <div className="text-2xl mb-2" data-id="element-1579">🎁</div>
          <h3 className="font-semibold text-white mb-1" data-id="element-1580">Nhận Thưởng</h3>
          <p className="text-sm text-[#B0B0B0]" data-id="element-1581">
            Cả hai cùng nhận tín dụng thưởng
          </p>
        </Card>
      </div>
    </div>;
}